import { useRef, useState } from 'react';
import ArrowDownIcon from '@/assets/icons/arrow-down.svg?react';
import { useClickOutside } from '@/hooks/useClickOutside';
import styles from './SingleSelectDropdown.module.scss';

export interface SingleSelectOption {
  value: string;
  label: string;
}

interface Props {
  label: string;
  options: SingleSelectOption[];
  value?: string;
  // eslint-disable-next-line no-unused-vars
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
  rounded?: boolean;
}

export function SingleSelectDropdown({ label, options, value, onChange, disabled = false, className = '', rounded = false }: Props) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const toggleTitle = `${open ? 'Close' : 'Open'} ${label} options`;
  const selected = options.find((option) => option.value === value);
  useClickOutside(wrapperRef, open ? 1 : null, () => setOpen(false));

  return (
    <div ref={wrapperRef} className={`${styles.wrapper} ${rounded ? styles.rounded : ''} ${className}`}>
      <fieldset className={styles.field}>
        <legend>{label}</legend>
        <button type="button" className={styles.trigger} title={toggleTitle} disabled={disabled} onClick={() => setOpen(!open)}>
          <span>{selected?.label ?? ''}</span>
          <ArrowDownIcon />
        </button>
      </fieldset>
      {open && !disabled && (
        <ul className={styles.options}>
          {options.map((option) => (
            <li key={option.value}>
              <button
                type="button"
                onClick={() => {
                  onChange(option.value);
                  setOpen(false);
                }}
              >
                {option.label}
              </button>
            </li>
          ))}
          {options.length === 0 && <li className={styles.empty}>No options available.</li>}
        </ul>
      )}
    </div>
  );
}
